import React, { Component } from "react";
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import { toggleAutoInvestActions } from "../../auth/ducks";
import { translate } from "react-i18next";
import { connect } from "react-redux";

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        toggleAutoInvest: toggleAutoInvestActions.request
    },
    dispatch)
});

@translate()
@connect(undefined, mapDispatchToProps)
export default class CancelAutoInvest extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        values: PropTypes.object.isRequired,
        actions: PropTypes.object.isRequired,
        accountId: PropTypes.string,
    }

    onClose = e => {
        this.props.onClose && this.props.onClose(e);
    };

    handleSubmit = () => {
        const {  actions  } = this.props

        actions.toggleAutoInvest({ accountId: this.props.accountId, data: {}, toggle: false })
        this.props.onClose()
    }

    render() {
        const { t } = this.props

        if (!this.props.show) {
            return null
        }

        return (
            <Modal
                visible
                title={t('Zrušenie autoinvestu')}
                onCancel={this.onClose}
                footer={
                    [
                        <Button type="primary" onClick={this.handleSubmit}>
                          {t('Potvrdiť')}
                        </Button> ,
                        <Button key="cancel" onClick={this.onClose}>
                          {t('Zavrieť')}
                        </Button> 
                    ]
                }
            >
            <div>
                <p>{t('Naozaj chcete zrušiť autoinvest?')}</p>
            </div>

            </Modal>
        )
    }


}


// WEBPACK FOOTER //
// ./src/features/allocations/components/CancelAutoInvest.js